import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const updateSavedViewName: YJSChangeHandler<
  DatabaseChangeType.UPDATE_SAVED_VIEW_NAME
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const view = db.viewsById[change.viewId];

    if (view) {
      view.applyNameDelta(change.delta);
    }
  });
};
